module.exports = __webpack_public_path__ + "static/media/LOGO-07.cded41e5.png";